import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Komitent } from './komitent';

@Component({
  selector: 'app-komitent',
  templateUrl: './komitent.component.html'
})
export class KomitentComponent extends BaseModalContainer<Komitent> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Komitent>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
